<template>
  <section>
    <SubLinks />
    <div class="flex space-x-4 items-end">
      <div class="font-heading text-3xl font-bold">Shows</div>
      <TextInput
        v-model="showQuery"
        placeholder="Search"
        classes="w-32 shrink grow-0 h-8"
        id="search-input"
        input-classes="w-full h-full"
      />
      <ButtonDefault label="Add" @click="goToShowAdd" id="add-show-button" classes="ml-auto" />
    </div>
    <div class="mt-6 flex flex-wrap" id="show-list">
      <div
        v-for="show in showsToDisplay"
        :key="show.id"
        class="flex items-center mb-7 w-full md:w-1/2 lg:w-1/3 2xl:w-1/4 grow-0 shrink"
        :id="`show-element-${show.id}`"
      >
        <picture
          v-if="hasShowImage(show.image)"
          @click="goToShowDetail(show.id)"
          :id="`show-image-${show.id}`"
        >
          <source :srcset="show.srcset.sqSm.src" type="image/webp" />
          <img
            class="cursor-pointer rounded-full mr-4 w-16 h-16 object-cover grow-[20]"
            :src="show.srcset.original.src"
            :alt="show.name"
          />
        </picture>
        <div
          v-else
          class="cursor-pointer rounded-full mr-4 w-16 h-16 bg-surface-base"
          @click="goToShowDetail(show.id)"
        ></div>
        <h3
          class="font-heading text-fg-link-primary font-semibold cursor-pointer shrink-[20] pr-5"
          @click="goToShowDetail(show.id)"
          id="show-name"
        >
          {{ show.name }}
        </h3>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { mapStores } from 'pinia'
import { defineComponent } from 'vue'

import ButtonDefault from '@/common/components/atoms/ButtonDefault.vue'
import SubLinks from '@/common/components/molecules/SubLinks.vue'
import TextInput from '@/common/components/molecules/TextInput.vue'
import { StoreShow } from '@/models'
import { useShowStore } from '@/stores/show'
import { cleanString } from '@/utils/utils'

export default defineComponent({
  name: 'ShowList',
  components: { SubLinks, ButtonDefault, TextInput },
  data() {
    return {
      showQuery: '',
    }
  },
  methods: {
    async goToShowDetail(id: number) {
      await this.$router.push({ name: 'showDetail', params: { id: `${id}` } })
    },
    async goToShowAdd() {
      await this.$router.push({ name: 'showAdd' })
    },
    hasShowImage(showImage: string | undefined) {
      if (!showImage) return false
      return showImage.match(/\.(jpeg|jpg|gif|png)$/) != null
    },
  },
  async created() {
    await Promise.all([this.showStore.fetchShows()])
  },
  computed: {
    ...mapStores(useShowStore),
    shows(): StoreShow[] {
      return this.showStore.shows
    },
    showsToDisplay(): StoreShow[] {
      const query = cleanString(this.showQuery)
      if (!query) return this.shows
      return this.shows.filter(show => cleanString(show.name as string).includes(query))
    },
  },
})
</script>
